import { render, staticRenderFns } from "./ConfirmationToast.vue?vue&type=template&id=2c9bf56d&scoped=true"
import script from "./ConfirmationToast.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmationToast.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ConfirmationToast.vue?vue&type=style&index=0&id=2c9bf56d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9bf56d",
  null
  
)

export default component.exports